'use client';

import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from 'react';
import { Toaster as Sonner } from 'sonner';
type ToasterProps = ComponentProps<typeof Sonner>;
export const SonnerToaster = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      unstyled: true,
      classNames: {
        icon: "mt-1",
        toast: "group toast font-inter flex gap-2 bg-white rounded-2xl p-2 group-[.toaster]:border group-[.toaster]:text-black group-[.toaster]:shadow-lg",
        title: "font-medium text-md",
        description: "group-[.toaster]:text-gray-dark text-sm",
        actionButton: "data-button:group-[.toaster]:bg-black data-button:group-[.toaster]:text-white",
        cancelButton: "data-button:group-[.toaster]:bg-white data-button:group-[.toaster]:text-black",
        error: "group-[.toaster]:bg-red-light group-[.toaster]:text-red-dark group-[.toaster]:border-red-dark",
        success: "group-[.toaster]:bg-green-light group-[.toaster]:text-green-dark group-[.toaster]:border-green-dark",
        warning: "group-[.toaster]:bg-orange-light group-[.toaster]:text-orange-dark group-[.toaster]:border-orange-dark",
        info: "group-[.toaster]:bg-blue-light group-[.toaster]:text-blue-dark group-[.toaster]:border-blue-dark"
      }
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <Sonner className="toaster group" position="bottom-center" toastOptions={t1} {...props} />;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};